import Reveal from "./Reveal";

const facts = [
  { label: "Established", value: "2006" },
  { label: "Focus", value: "Business IT & Technology Consulting" },
  { label: "Approach", value: "Proactive • Secure • Strategic" },
];

export default function About() {
  return (
    <section id="about" className="py-20 md:py-28 bg-white scroll-mt-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Image */}
          <Reveal>
            <div className="relative rounded-lg overflow-hidden">
              <div className="w-full h-[320px] md:h-[420px]">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20business%20technology%20infrastructure%20interior%20with%20sleek%20dark%20server%20racks%20and%20organized%20network%20cabling%2C%20soft%20electric%20blue%20ambient%20lighting%20glowing%20along%20the%20panels%2C%20clean%20professional%20enterprise%20data%20center%20environment%2C%20shallow%20depth%20of%20field%2C%20deep%20navy%20tones%20with%20cyan%20highlights%2C%20high%20end%20editorial%20photography%20style%2C%20no%20people%2C%20sophisticated%20and%20trustworthy%20mood&width=1200&height=900&seq=about-01&orientation=landscape"
                  alt="Modern business technology infrastructure"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="absolute bottom-4 left-4 right-4 rounded-md bg-foreground-950/70 backdrop-blur-sm px-4 py-3">
                <p className="text-sm text-white/90 font-medium">
                  Enterprise-quality IT, built for growing businesses.
                </p>
              </div>
            </div>
          </Reveal>

          {/* Copy */}
          <Reveal delay={100}>
            <span className="inline-block text-xs font-semibold uppercase tracking-[0.2em] text-primary-600">
              About Us
            </span>
            <h2 className="mt-3 font-heading font-extrabold text-foreground-950 text-3xl md:text-4xl tracking-tight">
              Technology Expertise You Can Trust
            </h2>
            <p className="mt-5 text-foreground-600 text-base md:text-lg leading-relaxed">
              The Tech Consultants LLC helps businesses navigate an increasingly complex technology
              landscape. We combine hands-on technical expertise with a business-first approach to
              IT, helping organizations reduce technology risk, improve productivity, and build a
              stronger foundation for growth.
            </p>

            <div className="mt-6 border-l-4 border-primary-500 bg-primary-50 rounded-r-md px-5 py-4">
              <p className="text-foreground-900 font-heading font-semibold text-base md:text-lg">
                We don't just manage technology. We help businesses make better use of it.
              </p>
            </div>

            <div className="mt-8 grid grid-cols-1 sm:grid-cols-3 gap-4">
              {facts.map((f) => (
                <div key={f.label} className="rounded-lg border border-background-200 bg-background-50 p-4">
                  <p className="text-xs uppercase tracking-[0.15em] text-foreground-500 font-semibold">
                    {f.label}
                  </p>
                  <p className="mt-1 font-heading font-bold text-foreground-950 text-sm">
                    {f.value}
                  </p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}